import { allowedRestrictedInputKeys } from "../constants";

export const getIsAllowedNumberString = (val: string) => {
  const isAllowedKey = allowedRestrictedInputKeys.includes(val);
  const isNumber = /^[0-9]+$/.test(val);
  return isAllowedKey || isNumber;
};
